import React from 'react'
import { FaFire, FaStar, FaCheckCircle } from 'react-icons/fa'

function BasicCourseAd() {
    const courses = [
        {
            title: "Básico",
            url: "https://www.udemy.com/course/curso-de-ingles-basico-adquira-uma-base-solida-no-idioma/?referralCode=DAD28CA36F4E068DB9E8"
        },
        {
            title: "Intermediário 1",
            url: "https://www.udemy.com/course/curso-de-ingles-intermediario-90-em-ingles-com-legendas/?referralCode=CAADBF2564957289B935"
        },
        {
            title: "Intermediário 2",
            url: "https://www.udemy.com/course/curso-de-ingles-intermediario-2-lane-antunes/?referralCode=EB310BD715B67485024A"
        }
    ]

    return (
        <div className="basic-course-ad w-full bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 py-3 md:py-4 px-4 md:px-6 shadow-lg border-b-2 border-orange-600 mt-16 md:mt-20">
            <div className="container mx-auto max-w-7xl">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-white">
                    {/* Left Side - Text */}
                    <div className="flex items-center gap-3 md:gap-4  justify-center md:justify-start">
                        <div className="flex items-center gap-2">
                            <FaFire className="text-yellow-300 text-xl md:text-2xl animate-pulse" />
                            <span className="font-bold text-sm md:text-base lg:text-lg">
                                🔥 OFERTA ESPECIAL
                            </span>
                        </div>
                        <div className="hidden flex items-center gap-2">
                            <span className="text-white/90">•</span>
                            <span className="font-semibold text-sm md:text-base">
                                Adquira já meu Curso Básico Completo!
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaStar className="text-yellow-300" />
                            <span className="font-semibold text-sm md:text-base">
                                Base sólida no idioma • Desconto exclusivo
                            </span>
                        </div>
                    </div>

                    {/* Right Side - Course Buttons */}
                    <div className="flex  items-center gap-2 md:gap-3 justify-center">
                        {courses.map((course, index) => (
                            <a
                                key={index}
                                href={course.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2  rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300"
                            >
                                <FaCheckCircle className="text-green-300" />
                                <span className="font-bold text-sm md:text-base">
                                    {course.title} →
                                </span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BasicCourseAd



